import { FaEllipsisH, FaEllipsisV } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Container, ContainerVertical } from "./style";

interface DetalhesProps {
  path: string;
  state?: any;
  target?: "_self" | "_blank";
}

export function RedirectDetalhes({
  path,
  state,
  target = "_self",
}: DetalhesProps) {
  return (
    <Container>
      <Link state={state} to={path} target={target}>
        <FaEllipsisH />
      </Link>
    </Container>
  );
}

export function RedirectDetalhesVertical({
  path,
  state,
  target,
}: DetalhesProps) {
  return (
    <ContainerVertical>
      <Link state={state} to={path}>
        <FaEllipsisV style={{ fontSize: "16px" }} />
      </Link>
    </ContainerVertical>
  );
}
